import React, { useState, useEffect } from 'react'; 
import { generateClient } from 'aws-amplify/api';
import { notificationsByRecipient } from '../graphql/queries';
import { onCreateNotification } from '../graphql/subscriptions';
import { updateNotification } from '../graphql/mutations';
import { FiBell } from 'react-icons/fi';
import './NotificationBell.css';

const NotificationBell = ({ userEmail }) => {
    const client = generateClient(); // Mantenemos el cliente aquí
    const [notifications, setNotifications] = useState([]);
    const [unreadCount, setUnreadCount] = useState(0);
    const [showDropdown, setShowDropdown] = useState(false);

    const playNotificationSound = () => {
        const audio = new Audio('https://assets.mixkit.co/active_storage/sfx/2869/2869-preview.mp3');
        audio.play().catch(e => console.log("Audio esperando interacción del usuario."));
    };

    useEffect(() => {
        if (!userEmail) return;

        const fetchNotifications = async () => {
            try {
                const res = await client.graphql({
                    query: notificationsByRecipient,
                    variables: { recipientEmail: userEmail, sortDirection: 'DESC' }
                });
                const items = res.data.notificationsByRecipient.items;
                setNotifications(items);
                setUnreadCount(items.filter(n => !n.isRead).length);
            } catch (err) { console.error(err); }
        };

        fetchNotifications();

        const sub = client.graphql({
            query: onCreateNotification,
            variables: { recipientEmail: userEmail }
        }).subscribe({
            next: ({ data }) => {
                const newNotif = data.onCreateNotification;
                setNotifications(prev => [newNotif, ...prev]);
                setUnreadCount(prev => prev + 1);
                playNotificationSound();
            },
            error: (err) => console.error(err)
        });

        return () => sub.unsubscribe();
    // CORRECCIÓN QUIRÚRGICA: Añadido 'client' como dependencia para limpiar el warning
    }, [userEmail, client]); 

    const markAsRead = async (notif) => {
        if (notif.isRead) return;
        try {
            await client.graphql({
                query: updateNotification,
                variables: { input: { id: notif.id, isRead: true } }
            });
            setNotifications(prev => prev.map(n => n.id === notif.id ? { ...n, isRead: true } : n));
            setUnreadCount(prev => Math.max(0, prev - 1));
        } catch (err) { console.error(err); }
    };

    return (
        <div className="bell-container">
            <div className="bell-icon-wrapper" onClick={() => setShowDropdown(!showDropdown)}>
                <FiBell size="24px" color={unreadCount > 0 ? "#D4AF37" : "#fff"} />
                {unreadCount > 0 && <span className="bell-badge">{unreadCount}</span>}
            </div>

            {showDropdown && (
                <div className="bell-dropdown">
                    <div className="bell-header">Notificaciones</div>
                    <div className="bell-list">
                        {notifications.length === 0 ? <div className="bell-empty">Sin avisos nuevos</div> : 
                            notifications.slice(0, 5).map(n => (
                                <div key={n.id} className={`bell-item ${n.isRead ? 'read' : 'unread'}`} onClick={() => markAsRead(n)}>
                                    <p className="notif-title">{n.title}</p>
                                    <p className="notif-msg">{n.message}</p>
                                    <small>{new Date(n.createdAt).toLocaleString()}</small>
                                </div>
                            ))
                        }
                    </div>
                </div>
            )}
        </div>
    );
};

export default NotificationBell;